import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["id", "data", "className", "render", "size", "operation", "data-component-name"],
    _excluded2 = ["className", "style", "active"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';
import classNames from '@jd/jmtd-tools/es/classnames';
import { getValue } from '../tools/util';
import LineTabs from '../LineTabs';
import ConfigConsumer from '../ConfigConsumer';
import BasicTabs from '../BasicTabs';
import ConfigProvider from '../ConfigProvider';
import { ACTIVE } from './util';

var Tabs = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);
    _this.tabsRef = [];
    _this.cxt = props.type(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var ref = this.ref,
          update = this.cxt.update;
      this.resizeObserver = new ResizeObserver(function () {
        update && update();
        ref.classList.add('jmtd-tabs-initialed');
      });
      this.resizeObserver.observe(ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var update = this.cxt.update;
      update && update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var resizeObserver = this.resizeObserver;
      resizeObserver.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          data = _this$props.data,
          className = _this$props.className,
          render = _this$props.render,
          size = _this$props.size,
          operation = _this$props.operation,
          trackComponentName = _this$props['data-component-name'],
          others = _objectWithoutProperties(_this$props, _excluded),
          _this$cxt = this.cxt,
          typeClassName = _this$cxt.className,
          typeItemClassName = _this$cxt.itemClassName,
          itemStyle = _this$cxt.itemStyle,
          typeRender = _this$cxt.render;

      this.tabsRef = [];
      this.activeTab = this.activeIndex = null;
      return /*#__PURE__*/React.createElement(ConfigConsumer, {
        size: size
      }, function (_ref) {
        var configSize = _ref.size;
        return /*#__PURE__*/React.createElement("div", {
          id: id,
          ref: function ref(el) {
            _this2.ref = el;
          },
          className: classNames('jmtd-tabs', {
            'jmtd-tabs-small': configSize === 'small',
            'jmtd-tabs-mini': configSize === 'mini'
          }, getValue(typeClassName), className),
          "data-component-name": trackComponentName,
          "data-outline": "Tabs",
          "data-outline-label-selector": ".jmtd-tabs-tab-active"
        }, operation && /*#__PURE__*/React.createElement("div", {
          className: "jmtd-tabs-operation"
        }, operation), /*#__PURE__*/React.createElement(ConfigProvider, {
          size: {
            middle: 'large',
            small: 'middle',
            mini: 'small'
          }[configSize !== null && configSize !== void 0 ? configSize : 'middle']
        }, typeRender(data.map(function (item, index) {
          var _render = render(item, others),
              itemClassName = _render.className,
              style = _render.style,
              active = _render.active,
              otherItemProps = _objectWithoutProperties(_render, _excluded2);

          return /*#__PURE__*/React.createElement("div", _extends({
            "data-event-name": "change",
            "data-event-content": true,
            className: classNames('jmtd-tabs-tab', itemClassName, typeItemClassName),
            style: _objectSpread(_objectSpread({}, itemStyle), style),
            ref: function ref(el) {
              if (el) {
                _this2.tabsRef[index] = el;
                el[ACTIVE] = active;

                if (active) {
                  _this2.activeTab = el;
                  _this2.activeIndex = index;
                }
              }
            },
            key: index
          }, otherItemProps));
        }))));
      });
    }
  }]);

  return Tabs;
}(PureComponent);

Tabs.propTypes = {
  id: PropTypes.string,
  type: PropTypes.func,
  data: PropTypes.array.isRequired,
  value: PropTypes.any,
  className: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  operation: PropTypes.node,
  render: PropTypes.func,
  'data-component-name': PropTypes.string
};
Tabs.defaultProps = {
  id: null,
  type: LineTabs,
  value: PropTypes,
  className: '',
  onChange: function onChange() {},
  size: null,
  operation: null,
  render: BasicTabs,
  'data-component-name': 'Tabs'
};
export default Tabs;